export type BookingStep = "service" | "date" | "modality" | "payment" | "confirm";

export interface FlowContext {
  /** True only when the chosen service supports both online and in-person. */
  modalityNeeded: boolean;
  /** Emergency bookings are online-only, so the modality step never applies. */
  emergency?: boolean;
}

export interface Selections {
  service: string | null;
  time: string | null;
  modality: "online" | "in_person" | null;
  payment: string | null;
}

const ALL_STEPS: BookingStep[] = ["service", "date", "modality", "payment", "confirm"];

export function visibleSteps(ctx: FlowContext): BookingStep[] {
  return ALL_STEPS.filter((step) => step !== "modality" || (ctx.modalityNeeded && !ctx.emergency));
}

export function nextStep(current: BookingStep, ctx: FlowContext): BookingStep {
  const steps = visibleSteps(ctx);
  const i = steps.indexOf(current);
  if (i === -1) return current;
  return steps[Math.min(i + 1, steps.length - 1)]!;
}

export function prevStep(current: BookingStep, ctx: FlowContext): BookingStep {
  const steps = visibleSteps(ctx);
  const i = steps.indexOf(current);
  if (i === -1) return current;
  return steps[Math.max(i - 1, 0)]!;
}

/**
 * Korak na koji se wizard vraća kad server odbije booking. 402 (firma nema
 * dovoljno sredstava, i za sufinansirani dio kartice / virmana) vraća na
 * plaćanje gdje se vidi osvježena podjela i ponovo bira način; 409 (termin
 * zauzet) vraća na izbor datuma. Ostajanje na potvrdi bez odabranog načina
 * plaćanja ostavlja prazan ekran i ugašeno dugme.
 */
export function stepAfterRejectedBooking(status: 402 | 409): BookingStep {
  return status === 402 ? "payment" : "date";
}

export function canAdvance(step: BookingStep, sel: Selections): boolean {
  switch (step) {
    case "service": return sel.service !== null;
    case "date": return sel.time !== null;
    case "modality": return sel.modality !== null;
    case "payment": return sel.payment !== null;
    case "confirm": return true;
  }
}
